import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';

import { salesforceActivityApi } from './api';
import { salesforceActivityQueryKey } from './salesforceActivityQueryKey';

export const useSalesforceActivityQuery = (companyDomain: string, isSalesforceEnabled?: boolean) => {
  const { isOpen } = useAppState();

  return useQuery({
    queryKey: salesforceActivityQueryKey.tasks(companyDomain),
    queryFn: async () => {
      return await salesforceActivityApi.getTasks(companyDomain);
    },
    enabled: isOpen && !!isSalesforceEnabled,
  });
};
